import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles(theme => ({
  default: {
    border: "solid 1px #005F87",
    backgroundColor: "#FFFFFF",
    color: "#005F87",
    "&:hover": {
      backgroundColor: "#DAECF0",
      borderColor: "#005F87",
      boxShadow: "0px 1px 6px 0px #0000004D"
    },
    "&:active": {
      backgroundColor: "#CDE6EB",
      borderColor: "#005F87",
      boxShadow: "0px 1px 2px 0px #0000004D"
    }
  },
  shared: {
    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.3)",
    borderRadius: 2,
    height: 32,
    "&:focus": {
      outline: "solid 2px #0F789B",
      boxShadow: "0px 1px 2px 0px #0000004D",
      outlineOffset: 2
    }
  },
  base: {
    border: "solid 1px #003750",
    backgroundColor: "#005F87",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#004D73",
      boxShadow: "0px 1px 6px 0px rgba(0, 0, 0, 0.3)",
      borderColor: "#003750"
    },
    "&:active": {
      backgroundColor: "#003750",
      boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.3)",
      borderColor: "#003750"
    }
  },
  error: {
    border: "solid 1px #840000",
    backgroundColor: "#DC0000",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#B00000",
      borderColor: "#840000"
    },
    "&:active": {
      backgroundColor: "#840000"
    }
  },
  caution: {
    border: "1px solid #923D1D",
    color: "#FFFFFF",
    backgroundColor: "#DC6914",
    "&:hover": {
      backgroundColor: "#B64C24",
      boxShadow: "0px 1px 6px 0px #0000004D",
      borderColor: "#923D1D"
    },
    "&:active": {
      backgroundColor: "#923D1D",
      boxShadow: "0px 1px 2px 0px rgba(26, 14, 14, 0.3)",
      borderColor: "#923D1D"
    }
  }
}));

interface BaseButtonProps {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  text: string;
  type?: "button" | "submit" | "reset" | undefined;
  styleType?: "base" | "error" | "caution" | "default";
}

const BaseButton: React.FC<BaseButtonProps> = ({
  onClick,
  text,
  type,
  styleType = "base",
  className
}) => {
  const classes = useStyles();
  return (
    <Button
      size="small"
      variant="outlined"
      className={`${classes.shared} ${classes[styleType]}${
        className ? " " + className : ""
      }`}
      disableRipple
      onClick={onClick}
      type={type}
    >
      {text}
    </Button>
  );
};

export default BaseButton;
